/**
 * Envía un evento a Microsoft Clarity.
 * Utilizamos la función global de clarity que se carga a través del script.
 */
export const ClaritySendEvent = (eventName: string) => {
  if (typeof window !== 'undefined' && typeof (window as any).clarity === 'function') {
    (window as any).clarity('event', eventName);
  }
};
